import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/service/auth.service';
import { SidebarNavItem } from 'src/app/component/sidebar-layout/sidebar-layout.component';
import { environment } from '../../../environments/environment';

const BASE_ADMIN_MENU: SidebarNavItem[] = [
  { label: '결제 캘린더', icon: '/assets/admin/icons8-calendar-48.png', link: '/admin/payment-calendar' },
  { label: '결제 관리', icon: '/assets/admin/icons8-calendar-check-48.png', link: '/admin/payments-v2' },
  { label: '결제 예약', icon: '/assets/admin/icons8-calendar-clock-48.png', link: '/admin/preorder' },
  { label: '상품 관리', icon: '/assets/admin/icons8-product-documents-48.png', link: '/admin/products-v2' },
  { label: '일정 관리', icon: '/assets/admin/icons-tag-alt-48.png', link: '/admin/schedule' },
  { label: '패키지 운영 v2', icon: '/assets/tossface/u1F68C.svg', link: '/admin/departures-v2' },
  {
    label: '외부채널 연동',
    icon: '/assets/tossface/u1F517.svg',
    link: '/admin/external-reservations',
  },
  {
    label: '외부채널 상품',
    icon: '/assets/tossface/u1F5C2.svg',
    link: '/admin/external-products',
  },
  { label: '사용자 관리', icon: '/assets/admin/icons8-team-48.png', link: '/admin/users' },
  {
    label: '사용자 그룹 관리',
    icon: '/assets/tossface/u1F468_u200D_u1F469_u200D_u1F467_u200D_u1F466.svg',
    link: '/admin/user-group',
  },
  { label: '호스트 관리', icon: '/assets/tossface/u1F9D1_u1F3FB_u200D_u1F33E.svg', link: '/admin/hosts' },
  { label: '정산 관리', icon: '/assets/admin/icons8-coins-48.png', link: '/admin/settlement' },
  { label: '사업단위 관리', icon: '/assets/tossface/u1F4C1.svg', link: '/admin/business-groups' },
  { label: '전시 관리', icon: '/assets/admin/icons8-numeric-48.png', link: '/admin/display' },
  { label: '이벤트 관리', icon: '/assets/admin/icons8-autumntime-48.png', link: '/admin/event' },
  { label: '블로그 관리', icon: '/assets/admin/icons8-typewriter-with-paper-48.png', link: '/admin/blog' },
  { label: '푸시 알림 캠페인', icon: '/assets/admin/u1F4F1-notification.svg', link: '/admin/push-campaigns' },
  { label: '메시지 관리', icon: '/assets/admin/icons8-chat-48.png', link: '/admin/inquiry' },
  { label: '1:1 문의', icon: '/assets/admin/icons8-chat-48.png', link: '/admin/cs-inquiry' },
  { label: '광고 캠페인 관리', icon: '/assets/tossface/u1F4E3.svg', link: '/admin/campaigns' },
  { label: '쿠폰 관리', icon: '/assets/admin/icons8-coupon-48.png', link: '/admin/coupon' },
  { label: '쿠폰 그룹 관리', icon: '/assets/tossface/u1F5C3.svg', link: '/admin/coupon-group' },
  { label: '설문 관리', icon: '/assets/tossface/u1F4CB.svg', link: '/admin/survey' },
  { label: '제휴몰 관리', icon: '/assets/admin/icons8-team-48.png', link: '/admin/alliance' },
  { label: '업체 프로필', icon: '/assets/tossface/u1F4DD.svg', link: '/admin/vendor-profiles' },
  { label: '설정 관리', icon: '/assets/admin/icons8-settings-48.png', link: '/admin/config' },
];

const WELFARE_POINT_MENU_ITEM: SidebarNavItem = {
  label: '복지포인트 관리',
  icon: '/assets/tossface/u1F4B3.svg',
  link: '/admin/internal-users',
  dividerBefore: true,
};

// 사후 조사용 모니터링 뷰어(어드민 전용). 관리 CRUD와 분리해 별도 모니터링 그룹으로 노출한다.
const MONITORING_MENU_ITEMS: SidebarNavItem[] = [
  {
    label: '감사 로그',
    icon: '/assets/tossface/u1F50D.svg',
    link: '/admin/audit-logs',
    dividerBefore: true,
  },
  {
    label: '알림톡 발송내역',
    icon: '/assets/admin/u1F4F1-alimtalk.svg',
    link: '/admin/alimtalk-logs',
  },
  { label: '푸시 알림 발송내역', icon: '/assets/admin/u1F4F1-notification.svg', link: '/admin/push-logs' },
];

@Component({
  selector: 'admin',
  templateUrl: './admin.page.html',
})
export class AdminPage implements OnInit {
  readonly mainDomainUrl = environment.webDomain;
  // 복지포인트는 new-admin과 같이 모니터링 그룹 아래에 온다(Angular에는 관리자 계정 메뉴가 없어 맨 끝).
  menu: SidebarNavItem[] = [...BASE_ADMIN_MENU, ...MONITORING_MENU_ITEMS];

  constructor(private authService: AuthService) {}

  ngOnInit() {
    // 복지포인트 메뉴 노출 여부는 서버가 내려주는 권한 플래그로 판단(프론트에 이메일 하드코딩 금지).
    this.authService.getCurrentUserFromServer().subscribe((user) => {
      if (user?.canAccessWelfarePoint) {
        this.menu = [...BASE_ADMIN_MENU, ...MONITORING_MENU_ITEMS, WELFARE_POINT_MENU_ITEM];
      }
    });
  }
}
